<template>
  <div :class="['t-spinner', { 't-spinner--small': small }]">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'TSpinner',
  props: {
    small: Boolean
  }
}
</script>
